// The bulk bar on the selected pre-leads: Keep (contacts and a draft), Remove… (one reason for all), Draft emails
// again, and Approve & send (usePreLeadActions).
import { Check, Loader2, PenLine, Send, X } from "lucide-react";
import { useListContext, useTranslate } from "ra-core";
import { Button } from "@/components/ui/button";

import type { PreLead } from "./types";
import { isRemovable, usePreLeadActions } from "./usePreLeadActions";

export const PreLeadBulkActions = () => {
  const translate = useTranslate();
  const { selectedIds, data = [], onUnselectItems } = useListContext<PreLead>();
  const { working, keep, approve, askRemove, removeDialog } =
    usePreLeadActions(onUnselectItems);

  const selected = data.filter((r) => selectedIds.includes(r.id));
  const found = selected.filter((r) => r.status === "found");
  const drafted = selected.filter(
    (r) => r.status === "kept" || r.status === "ready",
  );
  const removable = selected.filter(isRemovable);
  const allReady =
    selected.length > 0 && selected.every((r) => r.status === "ready");

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button
        variant="outline"
        disabled={working || !found.length}
        onClick={() => keep(found)}
      >
        {working ? <Loader2 className="animate-spin" /> : <Check />}
        {translate("resources.pre_leads.bulk.keep")}
      </Button>
      <Button
        variant="outline"
        disabled={working || !removable.length}
        onClick={() => askRemove(removable)}
      >
        <X />
        {translate("resources.pre_leads.bulk.remove")}
      </Button>
      <Button
        variant="outline"
        disabled={working || !drafted.length}
        onClick={() => keep(drafted)}
      >
        <PenLine />
        {translate("resources.pre_leads.bulk.draft")}
      </Button>
      <Button disabled={working || !allReady} onClick={() => approve(selected)}>
        <Send />
        {translate("resources.pre_leads.bulk.approve")}
      </Button>
      {removeDialog}
    </div>
  );
};
